function initializeFaqCopy() {
  /**
   * Copy deeplinks to clipboard
   */
  function copyDeeplinkToClipboard() {
    // Get all deeplink elements
    const deeplinkEls = document.querySelectorAll(".accordion__icon-wrapper");
    // Exit if there are no deeplink elements
    if (!deeplinkEls) return;
    // Loop through all deeplink elements
    deeplinkEls.forEach((deeplinkEl) => {
      // Add click event listener
      deeplinkEl.addEventListener("click", () => {
        // Get the value of the deeplink attribute
        const deeplink = deeplinkEl.getAttribute("data-value");
        // Exit if there is no deeplink value
        if (!deeplink) return;
        // Copy the deeplink to the clipboard
        navigator.clipboard.writeText(deeplink);
        // Show the copied message
        showCopiedMessage();
      });
    });
  }

  /**
   * Show the copied message
   */
  function showCopiedMessage() {
    // Get the copied message element
    const copiedMessageEl = document.querySelector(".copied-message");
    // Exit if there is no copied message element
    if (!copiedMessageEl) return;
    // Show the copied message
    copiedMessageEl.classList.add("show");
    // Hide the copied message after 3 seconds
    setTimeout(() => {
      copiedMessageEl.classList.remove("show");
    }, 3000);
  }

  /**
   * Add copy confirmation markup to the page
   */
  function addCopyConfirmationMarkup() {
    // Get the body element
    const bodyEl = document.querySelector("body");
    // Exit if there is no body element
    if (!bodyEl) return;
    // Create the copied message element
    const copiedMessageEl = document.createElement("div");
    copiedMessageEl.classList.add("copied-message");
    copiedMessageEl.innerHTML = `
      <div class="copied-message__content">
        Link kopiert
      </div>
    `;
    // Add the copied message element to the body element
    bodyEl.appendChild(copiedMessageEl);
  }

  /**
   * Initialize the faq deeplink script
   */
  function init() {
    copyDeeplinkToClipboard();
    addCopyConfirmationMarkup();
  }

  // Initialize the faq deeplink script
  init();
}

export default initializeFaqCopy;
